export const TimePastIcon = ({ color = "#706A85" }: { color?: string }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7319_22646)">
      <path
        d="M7 0C5.27675 0.00521289 3.61567 0.644315 2.33333 1.7955V0H1.16667V3.00008C1.16698 3.28728 1.2812 3.56263 1.48428 3.76572C1.68737 3.9688 1.96272 4.08302 2.24992 4.08333H5.25V2.91667H2.84608C3.79415 1.95625 5.0463 1.35485 6.38859 1.21522C7.73088 1.07558 9.08001 1.40639 10.2055 2.15111C11.3309 2.89583 12.1628 4.00824 12.5591 5.29829C12.9553 6.58834 12.8913 7.97595 12.378 9.22404C11.8647 10.4721 10.9339 11.5033 9.74469 12.1412C8.55547 12.7792 7.18162 12.9844 5.85788 12.7218C4.53415 12.4592 3.34267 11.7451 2.48703 10.7015C1.63139 9.65787 1.16469 8.34953 1.16667 7H0C0 8.38447 0.410543 9.73785 1.17971 10.889C1.94888 12.0401 3.04213 12.9373 4.32122 13.4672C5.6003 13.997 7.00777 14.1356 8.36563 13.8655C9.7235 13.5954 10.9708 12.9287 11.9497 11.9497C12.9287 10.9708 13.5954 9.7235 13.8655 8.36563C14.1356 7.00777 13.997 5.6003 13.4672 4.32122C12.9373 3.04213 12.0401 1.94888 10.889 1.17971C9.73785 0.410543 8.38447 0 7 0Z"
        fill={color}
      />
      <path
        d="M6.41699 4.08334V7.24151L8.33791 9.16243L9.16274 8.33759L7.58366 6.75851V4.08334H6.41699Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_7319_22646">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
